export const queryKeys = {
  debateList: 'debateList',
  infiniteDebateList: 'infiniteDebateList',
  debate: 'debate',
  signup: 'signup',
  user: 'user',
  guestbook: 'guestbook',
  like: 'like',
};
